import BaseApiClient from '../BaseApiClient';
import type {
  ForecastResponse,
  ForecastScope
} from '@/interfaces/Forecast.interface';

export type ForecastQueryParams = {
  scope: ForecastScope;
  from?: string;
  to?: string;
};

export class ApiForecast extends BaseApiClient {
  async getForecasts(params: ForecastQueryParams): Promise<ForecastResponse> {
    return new Promise((resolve, reject) => {
      this.client
        .get('forecasts', {
          params: {
            scope: params.scope,
            from: params.from,
            to: params.to
          },
          headers: {
            Version: '2025-11-14'
          }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { forecastQueryKeys } from './query-keys';
export type { ForecastQueryKeyParams } from './query-keys';
export { useForecastQuery } from './use-forecast-queries';
